import { CHARGE_BACK, CHARGE_BACK_ERROR } from "../actions/types";

const initialState = {
  return: null, // Add this property
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CHARGE_BACK_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case CHARGE_BACK:
      return {
        ...state,
        return: payload, 
        loading: false,
      };

    default:
      return state;
  }
}
